// DroppableSlot component
import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import { OrderImage } from '../OrderImage'

export const DroppableSlotRanking = ({
  backgroundNumber,
  background,
  isCorrectAnswer,
  isWrongAnswer,
  checkingMatches = true,
  wrapperStyle,
  showCorrectAnswer,
  gameType,
  draggableCard,
  isEditorial,
}) => {
  const { setNodeRef } = useDroppable({
    id: background.id,
  })

  return (
    <div style={wrapperStyle} ref={setNodeRef}>
      <OrderImage
        backgroundNumber={backgroundNumber}
        isDropped
        isWrongAnswer={isWrongAnswer}
        isCorrectAnswer={isCorrectAnswer || showCorrectAnswer}
        draggableCard={draggableCard}
        checkingMatches={checkingMatches}
        gameType={gameType}
        isEditorial={isEditorial}
      />
    </div>
  )
}
